// The invitation page's link and outcome (VisionPlatform customer-invitations CI-05, CI-06).

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type InvitationSearch = { id?: string; org?: string };

/** The ids from the invitation mail's link; anything that is not an id is dropped. */
export function validateInvitationSearch(search: Record<string, unknown>): InvitationSearch {
  const pick = (v: unknown) => (typeof v === "string" && UUID.test(v) ? v.toLowerCase() : undefined);
  return { id: pick(search.id), org: pick(search.org) };
}

export type InvitationOutcome = { kind: "open"; orgId?: string } | { kind: "notFound" };

/**
 * After /me has accepted every pending invitation for the verified address: open the invited organisation when the
 * person is now a member of it, Home when the link names none (mails sent before `org` was added), otherwise say the
 * invitation was not found for this account.
 */
export function invitationOutcome(
  memberships: readonly { org_id: string }[],
  org: string | undefined,
): InvitationOutcome {
  if (!org) return { kind: "open" };
  return memberships.some((m) => m.org_id.toLowerCase() === org) ? { kind: "open", orgId: org } : { kind: "notFound" };
}

/** The sign-in page tells someone arriving from an invitation about the set-password mail. */
export function isInvitationReturn(returnTo: string | undefined): boolean {
  return returnTo === "/invitation" || !!returnTo?.startsWith("/invitation?");
}
